'use client';

import { useEffect } from 'react';

/**
 * Захват yclid из URL для сквозной атрибуции Яндекс Директа
 * (ТЗ DIRECT-ANALYTICS, задача B).
 *
 * Атрибуция по первому клику: существующую cookie не перезаписываем.
 * ClientID Метрики (`_ym_uid`) ставит сам счётчик — здесь ничего не делаем.
 *
 * Параметр читаем из `window.location.search`, а не через `useSearchParams`:
 * тот требует Suspense-границы и переводит страницу в динамический рендер.
 */

const COOKIE_NAME = 'sp_yclid';
const MAX_LEN = 100;
const MAX_AGE = 7776000; // 90 дней

export default function AttributionCapture() {
  useEffect(() => {
    try {
      const yclidRaw = new URLSearchParams(window.location.search).get('yclid');
      if (!yclidRaw) return;

      // Уже есть атрибуция — не трогаем (первый клик важнее последнего).
      const already = document.cookie.split('; ').some((c) => c.startsWith(`${COOKIE_NAME}=`));
      if (already) return;

      const yclid = yclidRaw.slice(0, MAX_LEN);
      if (!/^[A-Za-z0-9_-]+$/.test(yclid)) return;

      // domain задаём только на боевом домене, иначе cookie не установится
      // на localhost и в превью-окружениях.
      const domain = window.location.hostname.endsWith('svoyprofi.ru') ? '; domain=.svoyprofi.ru' : '';
      document.cookie = `${COOKIE_NAME}=${yclid}; max-age=${MAX_AGE}; path=/; Secure; SameSite=Lax${domain}`;
    } catch {
      // Атрибуция вспомогательна — молча игнорируем любые сбои.
    }
  }, []);

  return null;
}
